import {
  Center,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  Table,
  Image,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableCaption,
  Box,
} from "@chakra-ui/react";
import { ButtonConsulta } from "./styles";
import { useNavigate } from "react-router-dom";
import { BsBoxArrowInLeft } from "react-icons/bs";
import { useEffect } from "react";
import * as S from "./styles";

const loading = "../../images/loading-verde.gif";

function ModalConsulta(dados) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  let navigate = useNavigate();

  console.log(dados);

  function verificaStatus(status) {
    const statusColor = {
      "CHAMADO NOVO": "#73ff00",
      PERDIDO: "#ff0000",
      "VENDA CONVERTIDA (PEDIDO)": "#80bd01",
      "EM ANÁLISE PARA FECHAMENTO": "#ff7e00",
      "LAYOUT ENCAMINHADO": "#ffff00",
      "EM NEGOCIAÇÃO": "#00ffea",
      "FEEDBACK DA PROPOSTA": "#0084ff",
      "PRIMEIRO CONTATO": "#e100ff",
    };

    if (statusColor[status]) {
      return statusColor[status];
    }
    return "#ff7e00";
  }

  useEffect(() => {
    //clicar enter para consultar
    function handleEnter(event) {
      if (event.keyCode === 13) {
        dados.getOrcamentoPedidos(onOpen);
      }
    }
    window.addEventListener("keydown", handleEnter);
    return () => {
      window.removeEventListener("keydown", handleEnter);
    };
  }, []);

  return (
    <Center>
      <ButtonConsulta
        _hover={{ backgroundColor: "#80bd01" }}
        _active={{ backgroundColor: "#80bd01" }}
        bgColor="#80bd01;"
        onClick={() => dados.getOrcamentoPedidos(onOpen)}
        boxShadow="none !important"
      >
        Consultar
      </ButtonConsulta>
      <Modal
        isOpen={isOpen}
        size={"6xl"}
        onClose={onClose}
        motionPreset="slideInBottom"
      >
        <ModalOverlay />
        <ModalContent maxH="85vh" overflowY="scroll">
          {dados.loading ? (
            <Box
              w="100%"
              h="100%"
              position="absolute"
              zIndex="99999"
              bgColor="white"
            >
              <Center mt="6rem" mb="4rem">
                <Image alt="loading" src={loading} />
              </Center>
            </Box>
          ) : (
            <></>
          )}
          <ModalHeader
            color="#80bd01"
            fontSize="30px"
            fontFamily="Akrobat ExtraBold"
          >
            Resultado da Consulta
          </ModalHeader>
          <ModalCloseButton boxShadow="none !important" color="#ff7e00" />
          <ModalBody>
            <Table variant="striped" colorScheme="blackAlpha">
              <TableCaption>
                <strong>
                  Clique no botão 'Acessar' para mais informações.
                </strong>
              </TableCaption>
              <Thead fontFamily="Akrobat ExtraBold" fontSize="sm">
                <Tr>
                  <Th>Link</Th>
                  <Th>Nº Proposta</Th>
                  <Th>Nº Nota</Th>
                  <Th>Tipo Operação</Th>
                  <Th>Nome do Parceiro</Th>
                  <Th>Contato</Th>
                  <Th>Nome Fantasia</Th>
                  <Th>Data movimentação</Th>
                  <Th width="200px">Desc. Funil de Vendas</Th>
                </Tr>
              </Thead>
              <Tbody fontFamily="Akrobat">
                {dados.dados.map((dado) => {
                  return (
                    <Tr
                      bg={
                        dado.nome_tipo_operacao.includes("PEDIDO")
                          ? "#e7ffb4"
                          : ""
                      }
                    >
                      <Td>
                        <Button
                          variant="link"
                          color="#80bd01"
                          onClick={() => {
                            parseInt(dado.codigo_tipo_operacao) === 33
                              ? navigate("/pedidos?p=" + dado.numero_proposta, [
                                  false,
                                ])
                              : navigate(
                                  "/orcamento?p=" + dado.numero_proposta,
                                  [false]
                                );
                          }}
                        >
                          Acessar
                        </Button>
                      </Td>
                      <Td>{dado.numero_proposta}</Td>
                      <Td>{dado.numero_nota}</Td>
                      <Td>{dado.nome_tipo_operacao}</Td>
                      <Td>{dado.nome_parceiro}</Td>
                      <Td>{dado.nome_contato}</Td>
                      <Td>{dado.nome_fantasia}</Td>
                      <Td width="100px">{dado.data_movimentacao}</Td>
                      <td>
                        {" "}
                        <S.StatusFunilVendas
                          color={verificaStatus(
                            dado.descricao_funil_vendas.trim()
                          )}
                        >
                          {dado.descricao_funil_vendas}
                        </S.StatusFunilVendas>
                      </td>
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
          </ModalBody>

          <ModalFooter>
            <Button
              leftIcon={<BsBoxArrowInLeft size="25px" />}
              _hover={{ backgroundColor: "#ff7e00" }}
              _active={{ backgroundColor: "#ff7e00" }}
              color="white"
              bgColor="#ff7e00"
              mr={3}
              onClick={onClose}
            >
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Center>
  );
}
export default ModalConsulta;
